import { Language } from './types';

const REFERRAL_LABELS = {
  referrerTitle: 'Did anyone recommend EFEX?',
  referrerInputLabel: 'Enter your referral code (optional)',
  referrerPlaceholder: 'Enter the code',
  referrerValidate: 'Validate code',
  referrerSkip: `I don't have a code`,
  referrerError: 'The code entered does not exist',
  referrerSuccess: 'Valid code!',
  referrerNavTitle: 'Refer a company',
  referrerNavMessage:
    'Share the code and receive your reward if the company you referred transacts at least USD $50,000 per month...',
  referrerNavMessage1: 'Win ',
  referrerNavMessageAmmount: '$250 USD ',
  referrerNavMessage2: '  per referral!',
  referrerNavButton: 'See code',
  referrerModalTitle: 'Refer a company',
  referrerModalCode: 'Your code:',
  referrerModalEarns: 'You earn:',
  referrerModalError: "Couldn't copy to clipboard, try again later",
  referrerModalSuccess: 'Code copied',
};

type LabelsLanguage = keyof typeof REFERRAL_LABELS;

const REFERRAL_LANGUAGE_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: REFERRAL_LABELS,
  ES: {
    referrerTitle: '¿Alguien te recomendó EFEX?',
    referrerInputLabel: 'Ingresa tu código de referido (opcional)',
    referrerPlaceholder: 'Ingrese el código',
    referrerValidate: 'Validar código',
    referrerSkip: 'No cuento con un código',
    referrerError: 'El código ingresado no existe',
    referrerSuccess: '¡Código válido!',
    referrerNavTitle: 'Refiere a una empresa',
    referrerNavMessage:
      'Comparte el código y recibe tu recompensa si la empresa que referiste transacciona al menos USD $50,000 al mes...',
    referrerNavMessage1: '¡Gana ',
    referrerNavMessageAmmount: '$250 USD ',
    referrerNavMessage2: ' por referido!',
    referrerNavButton: 'Ver código',
    referrerModalTitle: 'Refiere a una empresa',
    referrerModalCode: 'Tu código:',
    referrerModalEarns: 'Tus ganancias:',
    referrerModalError: 'No se pudo copiar al portapapeles, intente mas tarde',
    referrerModalSuccess: 'Código copiado',
  },
};

export default REFERRAL_LANGUAGE_LABELS;
